import PropTypes from 'prop-types';

const ArrowIcon = (props) => {
    const directionMap = {
        up: '-90deg',
        down: '90deg',
        left: '-180deg',
        right: '0deg',
    };
    return (
        <svg
            style={{
                height: props.size ? props.size : '',
                transform: `rotate(${directionMap[props.direction || 'up']})`,
            }}
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={props.colour || '#FFF'}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 8.00018C0 7.70795 0.118513 7.42769 0.329468 7.22106C0.540423 7.01442 0.826539 6.89833 1.12487 6.89833H14.1577L9.32746 2.16923C9.11624 1.96233 8.99757 1.68172 8.99757 1.38912C8.99757 1.09653 9.11624 0.815915 9.32746 0.609019C9.53868 0.402122 9.82516 0.285889 10.1239 0.285889C10.4226 0.285889 10.7091 0.402122 10.9203 0.609019L17.6695 7.22007C17.7743 7.32242 17.8574 7.44401 17.9141 7.57788C17.9708 7.71174 18 7.85524 18 8.00018C18 8.14511 17.9708 8.28861 17.9141 8.42247C17.8574 8.55634 17.7743 8.67793 17.6695 8.78028L10.9203 15.3913C10.7091 15.5982 10.4226 15.7145 10.1239 15.7145C9.82516 15.7145 9.53868 15.5982 9.32746 15.3913C9.11624 15.1844 8.99757 14.9038 8.99757 14.6112C8.99757 14.3186 9.11624 14.038 9.32746 13.8311L14.1577 9.10202H1.12487C0.826539 9.10202 0.540423 8.98593 0.329468 8.7793C0.118513 8.57266 0 8.2924 0 8.00018Z"
            />
        </svg>
    );
};

ArrowIcon.propTypes = {
    /** e.g. 5px */
    size: PropTypes.string,
    /** either up, down, left or right */
    direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
    /** any valid CSS colour */
    colour: PropTypes.string,
};

export default ArrowIcon;
